import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import BottomNav from "./components/BottomNav";
import EditProfileSheet from "./components/EditProfileSheet";
import LanguageSheet from "./components/LanguageSheet";
import InstallModal from "./components/InstallModal";
import TopBar from "./components/TopBar";
import { useAppState, AppStateProvider } from "./state/AppStateContext";
import CheckScreen from "./screens/CheckScreen";
import HistoryScreen from "./screens/HistoryScreen";
import NotFoundScreen from "./screens/NotFoundScreen";
import ProfileScreen from "./screens/ProfileScreen";
import { LANGUAGES, t } from "./i18n/strings";
import "./theme.css";

function WelcomeDialog() {
  const { welcomeOpen, completeWelcome, lang, setLang } = useAppState();
  const [languagePicked, setLanguagePicked] = useState(false);
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  if (!welcomeOpen) return null;

  function chooseLanguage(event) {
    setLang(event.target.value);
    setLanguagePicked(true);
  }

  return (
    <div style={styles.backdrop} role="presentation">
      <div style={styles.dialog} role="dialog" aria-modal="true" aria-labelledby="welcome-title" onClick={(event) => event.stopPropagation()}>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Vaya Taxi" style={styles.welcomeLogo} />
        <h2 id="welcome-title" style={styles.dialogTitle}>{t(lang, "welcomeTitle")}</h2>
        <p style={styles.dialogBody}>{t(lang, "welcomeBody")}</p>
        <label htmlFor="welcome-language" style={styles.languageLabel}>{t(lang, "chooseLanguage")}</label>
        <select id="welcome-language" value={languagePicked ? lang : ""} onChange={chooseLanguage} style={styles.languageSelect}>
          <option value="" disabled>{t(lang, "chooseLanguage")}</option>
          {Object.entries(LANGUAGES).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
        </select>
        <div style={styles.welcomeFields}>
          <label htmlFor="welcome-name" style={styles.languageLabel}>{t(lang, "yourName")}</label>
          <input
            id="welcome-name"
            className="input"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder={t(lang, "defaultName")}
            style={styles.welcomeInput}
          />
          <label htmlFor="welcome-rank" style={styles.languageLabel}>{t(lang, "homeTaxiRank")}</label>
          <input
            id="welcome-rank"
            className="input"
            value={area}
            onChange={(event) => setArea(event.target.value)}
            placeholder={t(lang, "homeTaxiRankPlaceholder")}
            style={styles.welcomeInput}
          />
        </div>
        <button type="button" className="btn btn-primary btn-block" disabled={!languagePicked} style={styles.dialogButton} onClick={() => completeWelcome(name, area)}>
          {t(lang, "gotIt")}
        </button>
      </div>
    </div>
  );
}

function AppLayout() {
  return (
    <div style={styles.viewport}>
      <div style={styles.app}>
        <TopBar />
        <main style={styles.content}>
          <Routes>
            <Route path="/" element={<CheckScreen />} />
            <Route path="/history" element={<HistoryScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
          </Routes>
        </main>
        <BottomNav />
        <WelcomeDialog />
        <InstallModal />
        <LanguageSheet />
        <EditProfileSheet />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppStateProvider>
        <AppLayout />
      </AppStateProvider>
    </BrowserRouter>
  );
}

const styles = {
  viewport: { minHeight: "100vh", display: "flex", justifyContent: "center", background: "#04060c" },
  app: { position: "relative", width: "100%", maxWidth: 480, minHeight: "100vh", display: "flex", flexDirection: "column", overflow: "hidden", background: "var(--color-bg)" },
  content: { flex: 1, overflowY: "auto" },
  backdrop: { position: "fixed", inset: 0, zIndex: 50, display: "grid", placeItems: "center", padding: 18, background: "rgba(4,12,20,.72)" },
  dialog: { width: "100%", maxWidth: 410, padding: 24, borderRadius: 24, background: "var(--color-surface)", boxShadow: "var(--shadow-md)" },
  welcomeLogo: { display: "block", width: 96, height: 96, objectFit: "contain", margin: "0 auto 14px", filter: "drop-shadow(0 0 14px rgba(32,198,183,.28))" },
  dialogTitle: { margin: "0 0 12px", textAlign: "center", fontFamily: "var(--font-heading)", fontSize: 25 },
  dialogBody: { margin: 0, color: "var(--color-neutral-700)", lineHeight: 1.55 },
  languageLabel: { display: "block", margin: "18px 0 6px", color: "var(--color-neutral-700)", fontSize: 13 },
  languageSelect: { width: "100%", height: 50, padding: "0 14px", border: "1px solid var(--color-divider)", borderRadius: 14, background: "var(--color-bg)", color: "var(--color-text)", font: "inherit" },
  welcomeFields: { marginTop: 14 },
  welcomeInput: { height: 48, borderRadius: 14 },
  dialogButton: { height: 52, marginTop: 20, fontSize: 16 },
};
